import * as React from "react"
import * as $ from "jquery"
import { ChangeEvennt } from "react"
import {connect} from "react-redux"
import { IPatientAllergy } from "@curefit/ehr-common";
import TypeAhead, { TypeAheadElement } from "../TypeAhead";
import {AppConstants, AppPlaceholders} from "../../utils/AppConstants";
import * as _ from "lodash";
import {IAppState} from "../../models/IAppState";
import IAllergyStaticData from "../../models/staticData/IAllergyStaticData";
import CustomSelect from "../CustomSelect";
import ModelFactory from "../../models/ModelFactory";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import {MedicationActions} from "../../actions/MedicationActions";
import TextAreaAutoResize from "../TextAreaAutoResize";

/**
 * Created by abhinav on 28/01/18.
 */

export interface IAllergyItemEditorProps {
    item: IPatientAllergy;
    onDataChange: (update: any) => any;
    allergiesStaticData: IAllergyStaticData;
    fetchAllergenByName: (allergen: string) => Promise<any>;
}

export interface IAllergyItemEditorState {
    validate: boolean
}

class AllergyItemEditor extends React.Component<IAllergyItemEditorProps, IAllergyItemEditorState> {
    private allergyItemDOM: any;

    constructor(props: IAllergyItemEditorProps) {
        super(props)
        this.state = {
            validate: false
        }
    }

    componentDidMount() {
        let myInstance = this;
        $(this.allergyItemDOM).find("input").on("blur", function() {
            setTimeout(function() {
                if ( $(myInstance.allergyItemDOM).find("input:focus").length === 0 ) {
                    myInstance.setState({validate: true})
                }
            }, 100)
        })
    }

    onAllergyNameChange = (input: string) => {
        let updatedItem = { ...this.props.item, internalValue: input, displayValue: input };
        this.props.onDataChange(updatedItem);

        return this.props.fetchAllergenByName(input).then(allergens => {
            let allergenTypeAhead: TypeAheadElement[] = [];
            _.map(allergens, (allergen) => {
                let typeAheadElement: TypeAheadElement = {
                    value: allergen.internalValue,
                    label: allergen.displayValue,
                    additionalInfoLabel: `${allergen.type}`,
                    others: {
                        type: allergen.type
                    }
                }
                allergenTypeAhead.push(typeAheadElement);
            })
            return Promise.resolve({options: allergenTypeAhead, completed: true});
        }).catch(error => {
            throw error;
        });
    };

    onAllergyNameSelect = (elem: TypeAheadElement) => {
        let updatedItem = { ...this.props.item, internalValue: elem.value, displayValue: elem.label, allergenType: elem.others.type.toLowerCase() };
        this.props.onDataChange(updatedItem);
    }

    onAllergySuspectedChange = (event: React.MouseEvent<HTMLInputElement>) => {
        let updatedItem = { ...this.props.item, suspected: this.props.item.suspected !== undefined ? !this.props.item.suspected : true }
        this.props.onDataChange(updatedItem);
    }

    onCommentChange = (event: React.SyntheticEvent<HTMLTextAreaElement>) => {
        let updatedItem = Object.assign({}, this.props.item, { comment: (event.target as HTMLTextAreaElement).value});
        this.props.onDataChange(updatedItem);
    };

    generateDropdownItems = (allergiesStaticData: IAllergyStaticData) => {
        let staticItems: IStaticDataValue[] = [];
        _.map(Object.keys(allergiesStaticData), (allergyItem) => {
            let staticItem = ModelFactory.createNewStaticItem();
            staticItem.internalValue = allergyItem;
            staticItem.displayValue = allergiesStaticData[allergyItem].displayText;
            staticItems.push(staticItem);
        })
        return staticItems;
    }

    onAllergyTypeChange = (value: string) => {
        let updatedItem = { ...this.props.item, allergenType: value };
        if (value === null) updatedItem = { ...updatedItem, internalValue: null, displayValue: null }
        this.props.onDataChange(updatedItem);
    }

    render() {
        let myInstance = this;
        let allergiesStaticData = this.props.allergiesStaticData;
        let selectedValue = this.props.item.allergenType !== null ? AppConstants.allergenTypes[this.props.item.allergenType].internalValue : null;
        let suspected = this.props.item.suspected;
        let allergyTypeValidationStatus = this.state.validate && _.isEmpty(this.props.item.allergenType) ? "error" : "";
        let allergenValidationStatus = this.state.validate && _.isEmpty(this.props.item.displayValue) ? "error" : "";
        return (
            <div className="allergy-item-editor" ref={(allergyItemDom) => this.allergyItemDOM = allergyItemDom}>
                <div className={`allergy-editor-allergen ${allergenValidationStatus}`}>
                    <TypeAhead name="allergy-allergen" widgetName={"AllergyItem"} value={this.props.item.displayValue || ""} placeholder={AppPlaceholders.ALLERGY_EDITVIEW_ALLERGEN} onTypeAheadChange={this.onAllergyNameChange} onTypeAheadSelect={this.onAllergyNameSelect} />
                </div>
                <div className={`allergy-editor-type ${allergyTypeValidationStatus}`}>
                    <CustomSelect dropdownValues={myInstance.generateDropdownItems(allergiesStaticData)} selectedValue={selectedValue} defaultValue={"Type"} updateDropdownValue={this.onAllergyTypeChange}/>
                </div>
                <div className="allergy-editor-suspected">
                    <input type="button" value="suspected" className={`yesOrNoButton ${suspected ? "active" : ""}`} onClick={this.onAllergySuspectedChange}/>
                </div>
                <div className="allergy-editor-comment">
                    <TextAreaAutoResize
                        name={"additional-comments-allergy"}
                        className={"textarea-input form-control"}
                        value={this.props.item.comment || ""}
                        placeholder={"Additional Comments"}
                        onChange={this.onCommentChange}
                        rows={2}
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: IAppState) => {
    let {allStaticDataNew} = state;
    return {allergiesStaticData: allStaticDataNew.allergy};
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        fetchAllergenByName: (input: string) => {
            return MedicationActions.loadAllergies(input);
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AllergyItemEditor);
